import { isFeatureEnabled } from 'owa-feature-flags';
import { getExtensionFromFileName } from 'owa-file';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

const emailFileExtensions: string[] = ['.eml', '.msg'];

export default function shouldPreviewEmailAttachment(attachment: AttachmentType): boolean {
    if (!isFeatureEnabled('doc-SxS-itemAttachment')) {
        return false;
    }

    const fileExtension = getExtensionFromFileName(attachment.Name);
    return !!fileExtension && emailFileExtensions.indexOf(fileExtension.toLowerCase()) >= 0;
}
